import {get} from 'lodash';
import {SELECTED_ROWS} from '../constants';

export const selectedRowsSelector = (state) => {
    return get(state, ['responsesTable', SELECTED_ROWS], []);
};
